import {NgModule} from '@angular/core';
import {CustomSettingsDialogHeaderComponent} from '@presentation/components/custom-settings-dialog/custom-settings-dialog-header.component';
import {CrudOverviewDataModule, EditorHeaderModule} from '@vdw/angular-component-library';
import {TextileDataSharedModule} from '../textile-data-shared.module';
import {AddBuggyComponent} from './add/add-buggy.component';
import {buggyRouting} from './buggy.routing';
import {BuggyCustomSettingsComponent} from './custom-settings/buggy-custom-settings.component';
import {BuggyOverviewPageComponent} from './overview/buggy-overview-page.component';

@NgModule({
  declarations: [BuggyOverviewPageComponent, AddBuggyComponent, BuggyCustomSettingsComponent],
  imports: [buggyRouting, TextileDataSharedModule, EditorHeaderModule, CrudOverviewDataModule, CustomSettingsDialogHeaderComponent]
})
export class BuggyModule {}
